import { supabase } from "../supabase";

const getUrl = (contextUrl: string): string => {
  const url = new URL(contextUrl);
  const pathname = url.pathname;
  const search = url.search;
  // TODO: Find a workaround for https://github.com/orval-labs/orval/issues/1185
  // It shows warning when orval generates the client.
  const baseUrl = import.meta.env.VITE_API_BASE;

  const requestUrl = new URL(`${baseUrl}${pathname}${search}`);

  return requestUrl.toString();
};

const getHeaders = async (headers?: HeadersInit): Promise<HeadersInit> => {
  const accessToken = (await supabase.auth.getSession()).data.session?.access_token;

  // add Authorization header to every request
  let _headers = { ...headers };
  if (accessToken !== undefined) {
    _headers = {
      ..._headers,
      Authorization: `Bearer ${accessToken}`,
    };
  }

  return _headers;
};

export const apiClient = async <T>(url: string, options: RequestInit): Promise<T> => {
  const requestUrl = getUrl(url);
  const requestHeaders = await getHeaders(options.headers);

  const requestInit: RequestInit = {
    ...options,
    headers: requestHeaders,
  };

  const request = new Request(requestUrl, requestInit);
  const response = await fetch(request);
  if (response.status === 401) {
    await supabase.auth.signOut();
    window.location.reload();
  }
  const data = await response.json();

  return { status: response.status, data, headers: response.headers } as T;
};
